var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "nav vue-header",
      style: _vm.brandingVars,
      attrs: { mode: _vm.activeMode }
    },
    [
      _c("div", { staticClass: "vue-header__left-col" }, [
        _c(
          "div",
          {
            staticClass: "vue-header__logo",
            attrs: { tabindex: "0" },
            on: { click: _vm.gotoDashboard }
          },
          [
            _c("VUELogoVonly", { staticClass: "vue-header__logo--mobile" }),
            _c("VUELogo", {
              staticClass: "vue-header__logo--desktop",
              attrs: { "data-testid": "header-logo" }
            })
          ],
          1
        ),
        _c("hr", { staticClass: "vue-header__vertical-div" }),
        _vm.showMenuButton
          ? _c(
              "button",
              {
                staticClass: "vue-header__menu-btn",
                class: _vm.isMenuOpen && "is-open",
                attrs: { "data-testid": "menu-button", id: "menu-button" },
                on: { click: _vm.handleMenu }
              },
              [
                _c("i", {
                  staticClass: "icon icon-menu-2",
                  attrs: { id: "menu-button-icon" }
                })
              ]
            )
          : _vm._e()
      ]),
      _c("div", { staticClass: "vue-header__right-col" }, [
        _c(
          "div",
          { staticClass: "vue-header__search" },
          [
            _vm.showGlobalSearch
              ? _c("VueGlobalSearch", {
                  attrs: { "data-testid": "global-search" }
                })
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "vue-header__notification" },
          [
            _vm.showNotifications
              ? _c("VueNotifications", {
                  attrs: { "data-testid": "notification-list" }
                })
              : _vm._e()
          ],
          1
        ),
        _vm.showHelp
          ? _c(
              "div",
              { class: ["vue-header__help"], on: { click: _vm.onHelpClick } },
              [
                _c("VueHelp", {
                  staticClass: "vue-header__help",
                  attrs: { "data-testid": "help" }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.showVerticalLine
          ? _c("hr", {
              staticClass: "vue-header__vertical-div",
              attrs: { "data-testid": "verticalDiv" }
            })
          : _vm._e(),
        _c(
          "div",
          { staticClass: "vue-header__profile-menu" },
          [
            _vm.showProfileMenu
              ? _c("VueProfileMenu", {
                  attrs: { "data-testid": "profile-menu" }
                })
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "vue-header__company-selector" },
          [
            _vm.showCompanySelector
              ? _c("VueCompanySelector", {
                  attrs: { "data-testid": "company-selector" }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }